import Dexie from "dexie";

export const db = new Dexie("BAC_Sarampion_DB");

db.version(1).stores({
  bac_visitas_pendientes: "++id, sincronizado, codigo_vivienda, territorio, comunidad, estado_vivienda, createdAt",
  bac_visitas_cache:      "[territorio+comunidad], cachedAt",
});

db.version(2).stores({
  bac_visitas_pendientes: "++id, sincronizado, codigo_vivienda, territorio, comunidad, estado_vivienda, createdAt",
  bac_visitas_cache:      "[territorio+comunidad], cachedAt",
  bac_fotos_pendientes:   "++id, sincronizado, codigo_vivienda, createdAt",
});

// v3: caché de catálogos (entrevistadores, líderes BAC, EPS, etnias,
// etc.) — vive en IndexedDB, NO en memoria ni en localStorage, así que
// sobrevive a cerrar el navegador/la app y a recargar la página. Es la
// base de que el formulario ya no dependa de la red para poder abrirse.
db.version(3).stores({
  bac_visitas_pendientes: "++id, sincronizado, codigo_vivienda, territorio, comunidad, estado_vivienda, createdAt",
  bac_visitas_cache:      "[territorio+comunidad], cachedAt",
  bac_fotos_pendientes:   "++id, sincronizado, codigo_vivienda, createdAt",
  bac_catalogos_cache:    "tipo, cachedAt",
});

// v4: la cola de fotos ahora distingue QUÉ foto es (de la vivienda, o
// del carnet de vacunación cara A/B) — necesario porque cada una se
// adjunta a un lugar distinto al sincronizar.
db.version(4).stores({
  bac_visitas_pendientes: "++id, sincronizado, codigo_vivienda, territorio, comunidad, estado_vivienda, createdAt",
  bac_visitas_cache:      "[territorio+comunidad], cachedAt",
  bac_fotos_pendientes:   "++id, sincronizado, codigo_vivienda, campo, createdAt",
  bac_catalogos_cache:    "tipo, cachedAt",
});

// v5: caché de la pestaña PAI — antes solo se cacheaban las visitas;
// la lista de PAI (con carnets y fotos) se pedía siempre en vivo, sin
// ningún respaldo offline.
db.version(5).stores({
  bac_visitas_pendientes: "++id, sincronizado, codigo_vivienda, territorio, comunidad, estado_vivienda, createdAt",
  bac_visitas_cache:      "[territorio+comunidad], cachedAt",
  bac_fotos_pendientes:   "++id, sincronizado, codigo_vivienda, campo, createdAt",
  bac_catalogos_cache:    "tipo, cachedAt",
  bac_pai_cache:          "[territorio+comunidad], cachedAt",
});

// v6: caché de la pestaña MRCV — mismo criterio que PAI, para que la
// tabla no se quede en blanco si se abre sin conexión.
db.version(6).stores({
  bac_visitas_pendientes: "++id, sincronizado, codigo_vivienda, territorio, comunidad, estado_vivienda, createdAt",
  bac_visitas_cache:      "[territorio+comunidad], cachedAt",
  bac_fotos_pendientes:   "++id, sincronizado, codigo_vivienda, campo, createdAt",
  bac_catalogos_cache:    "tipo, cachedAt",
  bac_pai_cache:          "[territorio+comunidad], cachedAt",
  bac_mrcv_cache:         "[territorio+comunidad], cachedAt",
});
// v7: módulo Disentimiento dentro de BAC.
//   - bac_disentimiento_pendientes: constancias hechas sin señal (o que
//     no alcanzaron a subir), con la firma en base64. Se borran apenas
//     llegan al servidor.
//   - bac_disentimiento_cache: última lista traída del servidor, para
//     que la pestaña se vea igual sin conexión.
db.version(7).stores({
  bac_visitas_pendientes: "++id, sincronizado, codigo_vivienda, territorio, comunidad, estado_vivienda, createdAt",
  bac_visitas_cache:      "[territorio+comunidad], cachedAt",
  bac_fotos_pendientes:   "++id, sincronizado, codigo_vivienda, campo, createdAt",
  bac_catalogos_cache:    "tipo, cachedAt",
  bac_pai_cache:          "[territorio+comunidad], cachedAt",
  bac_mrcv_cache:         "[territorio+comunidad], cachedAt",
  bac_disentimiento_pendientes: "++id, sincronizado, codigo, createdAt",
  bac_disentimiento_cache:      "clave, cachedAt",
});

// v8: Jornadas BAC — cada BAC es una jornada por comunidad.
//   - bac_jornadas_cache: última lista de jornadas de la comunidad (para
//     saber sin señal cuál está abierta y su líder).
//   - bac_jornadas_pendientes: jornadas abiertas en campo sin señal. Se
//     suben ANTES que las visitas al sincronizar.
db.version(8).stores({
  bac_visitas_pendientes: "++id, sincronizado, codigo_vivienda, territorio, comunidad, estado_vivienda, createdAt",
  bac_visitas_cache:      "[territorio+comunidad], cachedAt",
  bac_fotos_pendientes:   "++id, sincronizado, codigo_vivienda, campo, createdAt",
  bac_catalogos_cache:    "tipo, cachedAt",
  bac_pai_cache:          "[territorio+comunidad], cachedAt",
  bac_mrcv_cache:         "[territorio+comunidad], cachedAt",
  bac_disentimiento_pendientes: "++id, sincronizado, codigo, createdAt",
  bac_disentimiento_cache:      "clave, cachedAt",
  bac_jornadas_cache:      "[territorio+comunidad], cachedAt",
  bac_jornadas_pendientes: "++id, sincronizado, codigo, territorio, comunidad, createdAt",
});
